import styled from 'styled-components';
import { colorGrey900 } from 'styleUtils';
export var Nav = /*#__PURE__*/styled.nav.attrs({
  role: 'navigation'
}).withConfig({
  componentId: "sc-1cdchw3-0"
})([""]);
export var List = /*#__PURE__*/styled.ol.withConfig({
  componentId: "sc-1cdchw3-1"
})(["list-style:none;margin:0;padding:0;display:flex;align-items:center;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;scroll-snap-type:x proximity;font-size:11px;color:#7788b0;"]);
export var ListItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-1cdchw3-2"
})(["&:not(:last-child)::after{content:'/';padding:1ch;}&:last-child{scroll-snap-align:end;}"]);
export var Link = /*#__PURE__*/styled.a.withConfig({
  componentId: "sc-1cdchw3-3"
})(["color:currentColor;white-space:nowrap;&::first-letter{text-transform:uppercase;}"]);
export var CurrentPage = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1cdchw3-4"
})(["color:", ";white-space:nowrap;&::first-letter{text-transform:uppercase;}"], colorGrey900);